import {
	AddLocationMutation,
	RemoveLocationMutation,
	UpdateLocationMutation
} from "~/gql/mutations/customers.generated";
import { CustomerLocationsQuery } from "~/gql/queries/customer.generated";
import { LocationQuery, LocationsQuery } from "~/gql/queries/location.generated";
import { GetLocationSalesPeopleQuery, GetOrderLocationsQuery } from "~/gql/queries/order.generated";

export const locationEndpoints = {
	AddLocation: {
		invalidatesTags: ["Location", "Customer"] as AddTagTypes,
		transformResponse: (res: AddLocationMutation) => res
	},
	customerLocations: {
		providesTags: ["Location"] as AddTagTypes,
		transformResponse: (res: CustomerLocationsQuery) => res
	},
	GetLocationSalesPeople: {
		providesTags: ["Location"] as AddTagTypes,
		transformResponse: (res: GetLocationSalesPeopleQuery) => res
	},
	GetOrderLocations: {
		providesTags: ["Location"] as AddTagTypes,
		transformResponse: (res: GetOrderLocationsQuery) => res
	},
	location: {
		providesTags: ["Location"] as AddTagTypes,
		transformResponse: (res: LocationQuery) => res
	},
	locations: {
		providesTags: ["Location"] as AddTagTypes,
		transformResponse: (res: LocationsQuery) => res
	},
	RemoveLocation: {
		invalidatesTags: ["Location", "Customer"] as AddTagTypes,
		transformResponse: (res: RemoveLocationMutation) => res
	},
	UpdateLocation: {
		invalidatesTags: ["Location", "Customer"] as AddTagTypes,
		transformResponse: (res: UpdateLocationMutation) => res
	}
};
